import { gql } from "@grandvisionhq/graphql";
import { productFragment } from "../../../fragments/operations/fragments/product.js";
const GET_PRODUCTS_BY_SKUS = gql`
  query GetProductsBySKUs($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ...ProductFragment
    }
  }
  ${productFragment}
`;
export {
  GET_PRODUCTS_BY_SKUS
};
//# sourceMappingURL=get-products-by-skus.js.map
